function parseNumero(numero) {
    if (typeof numero === 'number') {
        return numero;
    }
    if (!numero) {
        return 0;
    }
    // extrai apenas o número
    let matches = numero.match(/\b\d[.,\d]*\b/);
    if (!matches) {
        return 0;
    }
    var valor = matches[0];
    return parseFloat(valor.replace('.', '').replace(',', '.'));
}

const _moneyMask = (value, includeCurrencySymbol) => {
	var formatted = _decimalPtBr(value, 2);

	return includeCurrencySymbol ? "R$ " + formatted : formatted;
}

const _decimalPtBr = (value, decimalPlaces) => {
	if (typeof value === "string")
		value = parseFloat(value);

	if (!value)
		value = 0;

	return value.toFixed(decimalPlaces).replace('.', ',').replace(/(\d)(?=(\d{3})+\,)/g, "$1.");
}

function validarEmail(value) {
    if (!value){
        return false;
    }
    let matchArroba = value.match(/@/g);
    return matchArroba && matchArroba.length === 1;
}

function validarTelefone(value){
    return !!(value && value.length >= 10 && parseInt(value));
}

function validarDataFutura(value){

    var parseDataSelecionada = new Date(value.split("/").reverse().join("/"));
    var dataAtual = new Date();

    if(parseDataSelecionada <= dataAtual)
        return true;
    else
        return false;
}

function validarCPF(strCPF) {
    var Soma;
    var Resto;
    var i;
    Soma = 0;

    if (strCPF == null)
        return true;

    if (strCPF == "00000000000") return false;

    for (i=1; i<=9; i++) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (11 - i);
        Resto = (Soma * 10) % 11;

    if ((Resto == 10) || (Resto == 11))  Resto = 0;
    if (Resto != parseInt(strCPF.substring(9, 10)) ) return false;

    Soma = 0;
    for (i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (12 - i);
        Resto = (Soma * 10) % 11;

    if ((Resto == 10) || (Resto == 11))  Resto = 0;
    if (Resto != parseInt(strCPF.substring(10, 11) ) ) return false;

    return true;
}

function validaExpiracao(mes, ano){
    if(mes != '' && ano != ''){
        return isExpirationDateValid(mes, ano)
    } else {
        return true;
    }
}

export function cnpjValidation(value) {
    if (!value) return false

    // Aceita receber o valor como string, número ou array com todos os dígitos
    const isString = typeof value === 'string'
    const validTypes = isString || Number.isInteger(value) || Array.isArray(value)

    // Elimina valor em formato inválido
    if (!validTypes) return false

    // Filtro inicial para entradas do tipo string
    if (isString) {
      // Limita ao máximo de 18 caracteres, para CNPJ formatado
      if (value.length > 18) return false

      // Teste Regex para veificar se é uma string apenas dígitos válida
      const digitsOnly = /^\d{14}$/.test(value)
      // Teste Regex para verificar se é uma string formatada válida
      const validFormat = /^\d{2}.\d{3}.\d{3}\/\d{4}-\d{2}$/.test(value)

      // Se o formato é válido, usa um truque para seguir o fluxo da validação
      if (digitsOnly || validFormat) true
      // Se não, retorna inválido
      else return false
    }

    // Guarda um array com todos os dígitos do valor
    const match = value.toString().match(/\d/g)
    const numbers = Array.isArray(match) ? match.map(Number) : []

    // Valida a quantidade de dígitos
    if (numbers.length !== 14) return false

    // Elimina inválidos com todos os dígitos iguais
    const items = [...new Set(numbers)]
    if (items.length === 1) return false

    // Cálculo validador
    const calc = (x) => {
      const slice = numbers.slice(0, x)
      let factor = x - 7
      let sum = 0

      for (let i = x; i >= 1; i--) {
        const n = slice[x - i]
        sum += n * factor--
        if (factor < 2) factor = 9
      }

      const result = 11 - (sum % 11)

      return result > 9 ? 0 : result
    }

    // Separa os 2 últimos dígitos de verificadores
    const digits = numbers.slice(12)

    // Valida 1o. dígito verificador
    const digit0 = calc(12)
    if (digit0 !== digits[0]) return false

    // Valida 2o. dígito verificador
    const digit1 = calc(13)
    return digit1 === digits[1]
  }

  // Referência: https://pt.wikipedia.org/wiki/Cadastro_Nacional_da_Pessoa_Jur%C3%ADdica

const KEY_QUANTIDADE_FOTOS = process.env.VUE_APP_KEY_QUANTIDADE_FOTOS;

const forms = {
    parseNumero,
	moneyMask: _moneyMask,
    validarTelefone,
    validarDataFutura,
    validarCPF,
    validaExpiracao,
    cnpjValidation

}

import {
    isValid,
    isExpirationDateValid,
    isSecurityCodeValid,
  } from 'creditcard.js';

export default {
    rules: {
        obrigatorio: (obrigatorio = true) => v => !obrigatorio || !!v || 'Preencha este campo',
        tamanho: n => v => !!v && v.length <= n || 'Quantidade de caracteres excede limite de: ' +n,
        tamanhoMin: n => v => !!v && v.length >= n || 'Quantidade de caracteres mínima de: 6',
        faixa: (min, max) => function (v) {
            let valor = parseNumero(v);
            return valor >= min && valor <= max || `Informe um valor entre ${min.toLocaleString('pt-BR')} e ${max.toLocaleString('pt-BR')}`
        },
        hora: value => {
            const pattern = /^([0-1]?[0-9]|2[0-3]):([0-5][0-9])([0-5][0-9])?$/;
            return !value || pattern.test(value) || 'Hora inválida';
        },
        quantidadeDecimalPositivo: value => {
            const pattern = /^(?!0?([\,\.]0?0)?$)([0-9]{0,9}([\,\.][0-9]{1,2})?)?$/;
            return !value || pattern.test(value) || 'Quantidade inválida';
        },
        gt: min => function (v) {
            let valor = parseNumero(v);
            return valor > min || `Informe um valor maior que ${min}`;
        },
        email: value => validarEmail(value) || 'Informe um e-mail válido',
        telefone: value => validarTelefone(value) || 'Informe um telefone válido (apenas dígitos)',
        emailOuTelefone: value => {
            return validarEmail(value) || validarTelefone(value) || 'Informe um e-mail ou telefone válido (apenas dígitos)'
        },
        cpf: value => validarCPF(value) || 'Informe um CPF válido',
        cnpj: value => cnpjValidation(value) || 'Informe um CNPJ válido',
        intervaloData: (inicio, fim) => function () {
            return inicio <= fim && fim >= inicio || `Data inicial deve ser menor que data final`
        },
        percentual: value => {
            const pattern = /(^100([.]0{1,2})?)$|(^\d{1,2}([.]\d{1,2})?)$/;
            return !value || pattern.test(value) || 'Percentual inválido (0-100)';
        },
        numeroCartao: value => isValid(value) || 'Número de cartão inválido',
        cvvValido: (numeroCartao, cvv) => isSecurityCodeValid(numeroCartao, cvv) || 'CVV inválido',
        dataValida: (mes, ano) => validaExpiracao(mes,ano) || 'Data Inválida',
        dataFutura: value => validarDataFutura(value) || 'Data Inválida',
        validarFormatoTelefone: (area, telefone) => {
            if (area && telefone && telefone.length == 9) {
                let value = area + telefone;
                const pattern = /^\(?0?([1-9]{2})\)?[-.\s]?((9[0-9]{4})[-.\s]?([0-9]{4})|([1-8][0-9]{3})[-.\s]?([0-9]{4}))$/g;
                return !value || pattern.test(value) || 'Telefone inválido';
            }
            return false;
        },
    },
    getQuantidadeFotosSalvas() {
        try {
            return parseInt(localStorage.getItem(KEY_QUANTIDADE_FOTOS));
        } catch {
            return 0;
        }
    },
    setQuantidadeFotosSalvas(qtde) {
        localStorage.setItem(KEY_QUANTIDADE_FOTOS, qtde);
    },

    forms
};






